/**
 * @member {string} success
 * @member {string} isValid
 * @member {string} message
 */
export class ValidDTO {
  constructor ({ success, isValid, message }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'success', Object.assign({ value: success }, properties));
    Object.defineProperty(this, 'isValid', Object.assign({ value: isValid }, properties));
    Object.defineProperty(this, 'message', Object.assign({ value: message }, properties));
    Object.freeze(this);
  }

  success;

  isValid;

  message;
}
